interface PositionButtonProps {
  label: string;
  live: boolean;
  pending: boolean;
  disabled: boolean;
  onPress: () => void;
}

export function PositionButton({ label, live, pending, disabled, onPress }: PositionButtonProps) {
  const statusText = pending ? 'Switching...' : live ? 'LIVE' : 'Standby';

  return (
    <button
      type="button"
      className={`position-btn ${live ? 'live' : ''} ${pending ? 'pending' : ''}`}
      disabled={disabled}
      onClick={onPress}
      aria-label={`${label}: ${statusText}`}
    >
      <span className="position-label">{label}</span>
      <span className="position-status">{statusText}</span>
    </button>
  );
}
